import { useSettings } from "~/settings";
import { formatToDay } from "./utils";

export function useFormatToDay(): (value: Date | bigint) => string {
  const { dateDisplay } = useSettings();

  return formatToDay.bind(null, dateDisplay);
}
